import { motion } from "framer-motion";
import type { ReactNode } from "react";

const SectionHeading = ({
  eyebrow,
  title,
  description,
}: {
  eyebrow: string;
  title: ReactNode;
  description?: string;
}) => (
  <motion.div
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
    className="mx-auto max-w-2xl text-center"
  >
    <p className="text-sm font-semibold uppercase tracking-wider text-theme-primary">
      {eyebrow}
    </p>
    <h2 className="mt-3 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
      {title}
    </h2>
    {description && (
      <p className="mt-4 text-lg leading-relaxed text-gray-500">
        {description}
      </p>
    )}
  </motion.div>
);

export default SectionHeading;
